import { create } from 'zustand';
import { StorageValue, persist } from 'zustand/middleware';

export const INFO_STORE_KEY = 'info-store';

// TypeScript 인터페이스 정의
type InfoState = {
  userId: string;
  accessToken: string;
  firstName: string;
  lastName: string;
  email: string;
  isLogin: boolean;
  memberRole: string;

  setInfo: (info: {
    accessToken: string;
    firstName: string;
    lastName: string;
    email: string;
    userId: string;
    memberRole: string;
  }) => void;

  setFirstName: (firstName: string) => void;
  setLastName: (lastName: string) => void;
  setEmail: (email: string) => void;

  resetInfo: () => void;

  getInfo: () => { firstName: string; lastName: string; email: string; userId: string; memberRole: string };
};

// Zustand Store 생성
export const useInfoStore = create(
  persist<InfoState>(
    (set, get) => ({
      accessToken: '',
      firstName: '',
      lastName: '',
      email: '',
      userId: '',
      isLogin: false,
      memberRole: '',

      setFirstName: (firstName) => set({ firstName }),
      setLastName: (lastName) => set({ lastName }),
      setEmail: (email) => set({ email }),
      setInfo: ({ accessToken, firstName, lastName, email, userId, memberRole }) => {
        return set({
          accessToken,
          firstName,
          lastName,
          email,
          userId,
          memberRole,
          isLogin: accessToken !== '' && firstName !== '' && lastName !== '' && email !== '',
        });
      },

      resetInfo: () => {
        set({
          accessToken: '',
          firstName: '',
          lastName: '',
          email: '',
          isLogin: false,
          userId: '',
          memberRole: '',
        });
      },

      getInfo: () => ({
        firstName: get().firstName,
        lastName: get().lastName,
        email: get().email,
        userId: get().userId,
        memberRole: get().memberRole,
      }),
    }),

    {
      name: INFO_STORE_KEY,
      // localStorage 사용: 탭 간 공유 + 새로고침/딥링크에서도 세션 유지.
      // (sessionStorage 는 탭 전용이라 새 탭/구글 검색 진입 시 로그아웃으로 시작 →
      //  보호 페이지에서 401 폭주 + Suspense 충돌로 에러 페이지가 뜨던 문제를 제거)
      storage: {
        getItem: (key): StorageValue<InfoState> | null => {
          const value = localStorage.getItem(key);
          return value ? JSON.parse(value) : null;
        },
        setItem: (key, value) => {
          localStorage.setItem(key, JSON.stringify(value));
        },
        removeItem: (key) => {
          localStorage.removeItem(key);
        },
      },
    },
  ),
);
